import { MESApiService, spParameter } from "@dexteel/mesf-core";
import { get } from "lodash-es";
import { Location } from "../models/Location";

export const getLocations = async (
	params: { locationId?: number | null; onlyStands?: boolean },
	signal?: AbortSignal,
) => {
	const apiService = new MESApiService();

	const parameters: spParameter[] = [];

	if (params.locationId)
		parameters.push({ name: "LocationId", value: params.locationId });
	if (params.onlyStands)
		parameters.push({ name: "IsStand", value: params.onlyStands });

	const resp = await apiService.callV2(
		"[M2].[GetLocations]",
		parameters,
		signal,
	);

	if (resp.ok) {
		return get(resp, "data.tables[0].rows", []) as Location[];
	} else {
		throw new Error(resp.message || "Error fetching locations");
	}
};
